//src/types/Client.ts

import {
  collection,
  CollectionReference,
  DocumentData,
  QueryDocumentSnapshot,
  SnapshotOptions,
  Timestamp
} from '@firebase/firestore'
import { createUser, MailTo, User } from './Account/AccountInterfaces'
import { DocI } from './Document'
import { createAddress, AddressWork, createAddressWork, Address } from './Helper/Address'
import { convertTimestampsToDates, FirebaseProperties } from './Helper/FirebaseProperties'
import { CurrentFinance, ObjectSummary, createCurrentFinance } from './Helper/Interfaces'
import { db } from '@/firebase'
import type { AccountBillingInfo } from './Account'
import { FirebaseCollections, FirestorePaths } from '@/utils/firestore/FirestorePaths'

export class Client extends FirebaseProperties {
  ClientID?: string = ''
  BusinessName?: string = ''
  addressHome?: Address = createAddress()
  addressWork: AddressWork = createAddressWork()
  user: User = createUser()
  mailTo: MailTo | null = null
  finance: CurrentFinance = createCurrentFinance()
  documents: DocI[] = []
  billing?: AccountBillingInfo

  financeLedgerCollection: CollectionReference | null = null

  constructor(data?: any) {
    super()
    Object.assign(this, data)
  }

  setId(storeName: string) {
    this.thisCollection = FirestorePaths.storeCollection(storeName, FirebaseCollections.Client)
    this.thisDocument = FirestorePaths.storeDocument(
      storeName,
      FirebaseCollections.Client,
      this.firebaseInfo.__id
    )
    this.financeLedgerCollection = collection(
      db,
      FirestorePaths.nestedCollection(this.thisDocument, FirebaseCollections.Finance)
    )
  }

  getSummary(): ObjectSummary {
    return {
      id: this.firebaseInfo.__id,
      name: this.getName(),
      active: true
    }
  }

  getName(): string {
    const middle = this.user.middlename ? this.user.middlename + ' ' : ''
    const personName = `${this.user.firstname} ${middle}${this.user.lastname}`.trim()
    return personName || this.BusinessName || this.firebaseInfo.__id
  }

  getId(): string {
    return this.firebaseInfo.__id
  }

  getSearchables(): string {
    return this.getName()
  }

  getActive(): boolean {
    return true
  }
}

export const ClientConverter = {
  toFirestore: (client: Client) => {
    client.firebaseInfo._updatedAt = Timestamp.now()
    const val = {
      BusinessName: client.BusinessName ?? '',
      ClientID: client.ClientID ?? '',
      addressHome: client.addressHome,
      addressWork: client.addressWork,
      user: client.user,
      mailTo: client.mailTo,
      documents: client.documents,
      billing: client.billing ?? null,

      //Firestore values
      firebaseInfo: client.firebaseInfo
    }
    return val
  },
  fromFirestore: (
    snapshot: QueryDocumentSnapshot<DocumentData, DocumentData>,
    options?: SnapshotOptions
  ) => {
    const data = snapshot.data(options)
    const convertedData = convertTimestampsToDates(data)
    return new Client(convertedData)
  }
}
